import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Roles } from 'app/auth/authRoles';
import WhiteButton from 'app/shared-components/buttons/WhiteButton';
import ClinicSelector from './ClinicSelector';
import { useClinicContext } from '../ClinicContext';

function PrescribingHeader({ user, hideSignatureButton, allowClinicChange = false }) {
  const { selectedClinicId, setSelectedClinicId, selectedClinic } = useClinicContext();
  const navigate = useNavigate();

  const isSupport = user?.roles?.includes(Roles.SUPPORT);
  const shouldShowSignatureButton =
    !hideSignatureButton && !isSupport && selectedClinic?.esignatureEnabled;

  const handleConfigureSignatures = () => {
    navigate('/prescribing/e-signatures');
  };

  const handleClinicChange = allowClinicChange ? setSelectedClinicId : undefined;

  return (
    <Box className="flex justify-between items-center p-8 shrink-0 bg-linear-to-r from-[#4db181] to-[#3f7284]">
      <ClinicSelector
        user={user}
        selectedClinicId={selectedClinicId}
        onClinicChange={handleClinicChange}
      />
      {shouldShowSignatureButton && (
        <Box className="flex items-center">
          <WhiteButton
            label="Configure e-Signature"
            cb={handleConfigureSignatures}
            classes="min-w-40"
          />
        </Box>
      )}
    </Box>
  );
}

export default PrescribingHeader;
